import { render } from "./ComposeRelation.vue?vue&type=template&id=52e21586&scoped=true"
import script from "./ComposeRelation.vue?vue&type=script&lang=js"
export * from "./ComposeRelation.vue?vue&type=script&lang=js"

import "./ComposeRelation.vue?vue&type=style&index=0&id=52e21586&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e21586"]])

export default __exports__